import { a as d, j as i } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as o } from "../../1-foundations/Colors/Colors.js";
import { I as m } from "../../../Icon-D8QUNSZR.js";
import "../../../FeatureFlagProvider-BgPZZ37K.js";
import "react";
import "@ionic/react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../../organisms/LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
const a = {
  container: ({
    isActive: r,
    isDisabled: t,
    activeBgColor: n,
    iconColor: e,
    label: l
  }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    background: r ? o[n] : "transparent",
    padding: l ? "16px 8px" : 8,
    cursor: t ? "not-allowed" : "pointer",
    border: `2px solid ${t ? o.slate300 : r ? e === "black" ? o.blue500 : o[e] : o.black}`,
    borderRadius: 8,
    width: "100%"
  }),
  label: ({
    isDisabled: r,
    isSelected: t
  }) => ({
    margin: 0,
    fontSize: 14,
    lineHeight: "24px",
    textAlign: "center",
    color: r ? t ? o.black : o.slate300 : o.black
  })
};
function j(r) {
  const {
    icon: t,
    isDisabled: n,
    isSelected: e,
    label: l,
    onChange: c = () => {
    },
    value: s,
    activeBgColor: p = "white300"
  } = r;
  function b() {
    return n ? e ? o.black : o.slate300 : e && t.color === "black" ? o.blue500 : o[t.color];
  }
  return /* @__PURE__ */ d("button", {
    "data-testid": `choice-button-${l}`,
    style: a.container({
      isActive: e,
      isDisabled: n,
      activeBgColor: p,
      iconColor: t.color,
      label: l
    }),
    "aria-checked": e,
    tabIndex: 0,
    onClick: () => {
      !n && !e && c(s);
    },
    children: [/* @__PURE__ */ i(m, {
      name: t.name,
      color: b()
    }), l && /* @__PURE__ */ i("p", {
      style: a.label({
        isDisabled: n,
        isSelected: e
      }),
      children: l
    })]
  });
}
export {
  j as ChoiceButton
};
